import Link from 'next/link'

import { CommentData } from '@liveblocks/client'
import { Comment as LiveblocksComment } from '@liveblocks/react-ui/primitives'

import { cn } from '@/dc-shared-web/src'

import Mention from '@/app/core/components/commenting/Mention'

import NotificationResolvedUserName from '@/app/core/components/notification/NotificationResolvedUserName'

export default function NotificationComment({
  comment,
  indent,
}: {
  comment: CommentData
  indent?: boolean
}) {
  return (
    <div
      className={cn(indent && 'tw-pl-2 tw-border-l-2 tw-border-neutral-200')}
    >
      <div>
        <NotificationResolvedUserName
          userId={comment.userId}
          className='tw-text-sm tw-text-neutral-300'
        />
      </div>
      <LiveblocksComment.Body
        body={comment.body}
        components={{
          Mention: ({ userId }) => (
            <Mention
              userId={userId}
              className='tw-inline-block tw-rounded tw-bg-primary-100 tw-text-primary-600 tw-px-1'
            />
          ),
          Link: ({ href, children }) => <Link href={href}>{children}</Link>,
        }}
        className='tw-line-clamp-3 tw-text-sm'
      />
    </div>
  )
}
